import type { AuthProvider } from '../interfaces/auth';

export const SSOProvider: Record<string, AuthProvider> = {
  Google: 'Google',
  Okta: { custom: 'ACTransit' },
};
